module.exports = __webpack_public_path__ + "static/media/eg1.7a29f518.webp";